const initialState = {
  loading: false,
  isAlEnabled: false,
  isPsEnabled: false,
  isPsMPEnabled: false,
  error: false,
  errorMsg: "",
};

const dataSubReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CHECK_DATASUB_REQUEST":
      return {
        ...state,
        loading: true,
        error: false,
        errorMsg: "",
      };
    case "CHECK_DATASUB_SUCCESS":
      return {
        ...state,
        loading: false,
        isAlEnabled: action.payload.isAlEnabled,
        isPsEnabled: action.payload.isPsEnabled,
        isPsMPEnabled: action.payload.isPsMPEnabled,
        // cost: action.payload.cost,
        error: false,
        errorMsg: "",
      };
    case "CHECK_DATASUB_FAILED":
      return {
        ...initialState,
        loading: false,
        error: true,
        errorMsg: action.payload,
      };
    default:
      return state;
  }
};

export default dataSubReducer;
